import { render, staticRenderFns } from "./trained.vue?vue&type=template&id=8d33be70"
import script from "./trained.vue?vue&type=script&lang=js"
export * from "./trained.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports